import get from '@invitato/helpers/dist/getLocale';

export default {
  title: get('Kedua Mempelai', 'The Groom & Bride'),
};